import {initCsrfForms} from "./helpers/csrf.js";
import {color} from "./helpers/color.js";
import {pages} from "./pages/pages.js";
import {sliders, swiper_update_height} from "./sliders/sliders.js";
import {media} from "./helpers/media.js";
import {eventDocument} from "./helpers/eventDocument.js";
import {littleThings} from "./little-things.js";
import {rangeInputFuncInit} from "./range/rangeInputFunc.js";
import {alertFuncPreloadInit} from "./alert/alertFunc.js";
import {toSVG} from "./helpers/toSVG.js";
import './helpers/js_form.js'; 
import { initFilters } from "./helpers/gameFilters.js";
import { initCheckboxes } from "./helpers/checkbox.js";
import { otpInput } from "./helpers/otpInput.js";
import { renderTotpQr } from "./helpers/totpQr.js";
import { totpSwitch } from "./helpers/totpSwitch.js";
import {grecaptchaCallback} from "./valid/grecaptcha.js";
import './valid/login.js';
import { wsSubscribe } from "./ws.js";

// Register before DOMContentLoaded and the UI initialization callbacks.
initCsrfForms();

// Execute wsSubscribe immediately if wsToken is defined
if (typeof wsToken !== "undefined" && wsToken) {
    wsSubscribe(wsToken);
}

window.color = color;
window.toSVG = toSVG;
window.grecaptchaCallback = grecaptchaCallback;

document.addEventListener('DOMContentLoaded', () => {
    sliders();
    //window.swiper_update_height = swiper_update_height;
    media();
    // Initial HTML must use data-totp-uri without external src/srcset: image
    // requests can start before DOMContentLoaded, so replacing them here is too late.
    renderTotpQr();
    totpSwitch(); //до eventDocument: клик по переключателю 2FA не должен двигать радио
    otpInput(); //до eventDocument, чтобы значение поля кода было отфильтровано раньше, чем его прочитает valid/form.js
    eventDocument();
    pages();
    littleThings();
    window.littleThings = littleThings;
    var content = document.getElementById('content');
    rangeInputFuncInit();
    alertFuncPreloadInit();
    initFilters();
    initCheckboxes();



    window.items = () => console.log('items call try');//items;

    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/service_worker.js').then(registration => {
            console.log('SW registered: ', registration);
        }).catch(registrationError => {
            console.log('SW registration failed: ', registrationError);
        });
    }



    import(/* webpackPreload: true */ './google.js')
        .catch(err => {
            console.error("google load error", err);
        });


    if ($("input.phone_js_mask").length || $("input.card_ValidDate_js_mask").length || $("input.card_number_js_mask").length || $("input.webmoney_js_mask").length) {
        import(/* webpackPreload: true */ './helpers/inputmask.js')
            .catch(err => {
                console.error("inputmask load error", err);
            });
    }
    
    if (typeof fpr !== "undefined" && fpr) {
        import(/* webpackPreload: true */ './fpr.js')
        .catch(err => {
            console.error("fpr load error", err);
        });
    }

    // Remove the ws.js import from here
    // if (typeof wsToken !== "undefined" &&   wsToken) {
    //     import(/* webpackPreload: true */ './ws.js')
    //     .then(ws => {
    //         ws.wsSubscribe(wsToken);
    //     })
    //     .catch(err => {
    //         console.error("ws load error", err);
    //     });
    // }
});
